module.exports = __webpack_public_path__ + "static/media/Gotham-Bold.c5da51a0.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./src/fonts/Gotham-Bold.eot
 ** module id = 1332
 ** module chunks = 0
 **/